import { Component, HostBinding } from "@angular/core";

@Component({
  selector: "ngx-view-rating-placeholder",
  templateUrl: "view-rating-placeholder.component.html",
  styleUrls: ["view-rating-placeholder.component.scss"],
})
export class ViewRatingPlaceholderComponent {
  @HostBinding("attr.aria-label")
  label = "Loading";
}
